<template>
	<div>
		<div class="row">
			<div class="col-lg-6">
				<label for="">Fecha *</label>
                <v-date-picker :masks="{input:'DD-MM-YYYY'}" v-model="VehiculoSiniestro.Fecha" :mode="typeCalendar"
					:popover="{
						placement: 'bottom',
						visibility: 'click'
					}"
					:input-props="{
						class: 'form-control cal-black',
						style: 'cursor:pointer;'
					}"
                    :locale="'es-MX'"
				/>
			</div>
			<div class="col-lg-6">
				<label>Tipo *</label>
				<select v-model="VehiculoSiniestro.Tipo" class="form-control">
					<option value="">--Tipo--</option>
					<option value="1">Sin Seguro</option>
					<option value="2">Con Seguro</option>
					<option value="3">Seguro Terceros</option>
				</select>
			</div>
		</div>
		<div class="row mt-2">
			<div class="col-lg-12">
				<label>Archivo</label>
				<div class="custom-file-input-image">
					<input @change="SubirArchivo()" type="file" accept="application/pdf" ref="siniestro" class="custom-file-input" id="validatedCustomFile" required>
					<input type="text" v-model="Archivo" class="form-control">
					<button type="button" class=""><i class="fas fa-paperclip"></i></button>
				</div>
			</div>
		</div>
		<div class="row mt-2">
			<div class="col-lg-12">
				<label for="">Observaciones</label>
				<textarea class="form-control" v-model="VehiculoSiniestro.Observaciones" cols="10" rows="4"></textarea>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name:"Siniestro",
    props:["poBtnSave","pIdVehiculo"],
	data() {
        return {
            Modal:true,
            FormName:'Siniestro',
            EmitSeccion:this.poBtnSave.EmitSeccion,
            VehiculoSiniestro:{
                IdVehiculoSiniestro:0,
                IdVehiculo:0,
                Fecha:'',
				Tipo:'',
                Observaciones:'',
				Archivo:''
            },
			Archivo:'',
            errorvalidacion:[]
        }
    },
	methods: {
		Guardar(){
            let Fecha='';
            if (this.VehiculoSiniestro.Fecha!='' && this.VehiculoSiniestro.Fecha!=undefined) {
                let day=this.VehiculoSiniestro.Fecha.getDate();
                let month=this.VehiculoSiniestro.Fecha.getMonth()+1;
                let year=this.VehiculoSiniestro.Fecha.getFullYear();
                Fecha=year+'-'+month+'-'+day;   
            }
            let formData=new FormData();
            formData.set('IdVehiculoSiniestro',this.VehiculoSiniestro.IdVehiculoSiniestro);
            formData.set('IdVehiculo',this.VehiculoSiniestro.IdVehiculo);
            formData.set('Tipo',this.VehiculoSiniestro.Tipo);
			formData.set('Archivo',this.VehiculoSiniestro.Archivo);
            formData.set('Observaciones',this.VehiculoSiniestro.Observaciones);
            formData.set('Fecha',Fecha);
			let image=this.$refs.siniestro.files[0];
			formData.append('ArchivoFile',image);
            this.poBtnSave.toast=0;
            this.poBtnSave.disableBtn=true;
            this.$http.post('vehiculosiniestro/post',formData).then((res)=>{
                this.poBtnSave.disableBtn=false; 
                this.poBtnSave.toast=1;
                $("#Siniestro").modal("hide");
                this.bus.$emit('ListaPrincipal');
            }).catch((err)=>{
                this.errorvalidacion=err.response.data.message.errores;
                this.poBtnSave.disableBtn=false;
                this.poBtnSave.toast=2;
            });
        },
		Limpiar(){
            this.VehiculoSiniestro={
                IdVehiculoSiniestro:0,
                IdVehiculo:0,
                Fecha:new Date(),
				Tipo:'',
                Observaciones:'',
				Archivo:''
            },
			this.Archivo='Elegir archivo (1MB)';
        },
		Recuperar(){
            this.$http.get('vehiculosiniestro/recovery',{
                params:{
                    IdVehiculoSiniestro:this.VehiculoSiniestro.IdVehiculoSiniestro
                }
            }).then((res)=>{
                const objres=res.data.data.vehiculosiniestro;
                this.VehiculoSiniestro.IdVehiculoSiniestro=objres.IdVehiculoSiniestro;
                this.VehiculoSiniestro.IdVehiculo=objres.IdVehiculo;
                this.VehiculoSiniestro.Tipo=objres.Tipo;
                this.VehiculoSiniestro.Observaciones=objres.Observaciones;
				this.VehiculoSiniestro.Archivo=objres.Archivo;
                let formatedDate = objres.Fecha.replace(/-/g, "\/");
                this.VehiculoSiniestro.Fecha=new Date(formatedDate);
				this.Archivo=objres.Archivo;
            })
        },
		SubirArchivo(){
			const image = this.$refs.siniestro.files[0];

            var FileSize = image.size / 1024 / 1024; // in MB
            if (FileSize > 1) {
                this.$toast.info('Solo se puede subir archivos menores a 1 MB');
                const  input  = this.$refs.siniestro;
                input .type = 'text'
                input .type = 'file';
                return false;
            }
                        
            var allowedExtensions = /(\.pdf|\.PDF)$/i;
            if(!allowedExtensions.exec(image.name)){
                this.$toast.info('Extenciones permitidas .pdf');
                const  input  = this.$refs.siniestro;
                input.type = 'text'
                input.type = 'file';
                this.Archivo='Elegir archivo (1MB)';
                return false;
            }

            this.Archivo=image.name;
		}
	},
	created() {
		this.bus.$off("NewModal_"+this.EmitSeccion);
        this.bus.$on("NewModal_"+this.EmitSeccion,(data,Id,IdVehiculo)=>{
            this.poBtnSave.disableBtn=false;
            this.bus.$off("Save_"+this.EmitSeccion);
            this.bus.$on("Save_"+this.EmitSeccion, () => {
				this.Guardar();
			});
            this.Limpiar();
            if (IdVehiculo!==undefined) {
                this.VehiculoSiniestro.IdVehiculo=IdVehiculo;
            }
            if (Id > 0) {
				this.VehiculoSiniestro.IdVehiculoSiniestro = Id;
				this.Recuperar();
			}
        });
	},
	computed:{
        typeCalendar:function(){
            return 'single';
        }
    }
}
</script>

<style>

</style>
